import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * A small ⓘ that explains the element next to it on hover or keyboard focus.
 * Pure presentation: the text comes from debug-help.ts.
 */
@Component({
  selector: 'app-info-tip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <span class="group relative inline-flex align-middle" tabindex="0" [attr.aria-label]="text">
      <span class="flex h-3.5 w-3.5 cursor-help items-center justify-center rounded-full border border-current text-[9px] font-semibold leading-none opacity-60 group-hover:opacity-100 group-focus:opacity-100">i</span>
      <span role="tooltip"
        class="pointer-events-none absolute bottom-full z-30 mb-1.5 hidden w-64 rounded-md border border-[#EAEAEA] bg-white p-2 text-left text-[11px] font-normal normal-case leading-snug tracking-normal text-slate-700 shadow-lg group-hover:block group-focus:block dark:border-line dark:bg-surface-2 dark:text-ink-soft"
        [class]="side === 'left' ? 'right-0' : side === 'right' ? 'left-0' : 'left-1/2 -translate-x-1/2'">{{ text }}</span>
    </span>`,
})
export class InfoTipComponent {
  @Input({ required: true }) text = '';
  /** Which way the bubble opens, so it stays inside the panel near an edge. */
  @Input() side: 'left' | 'right' | 'center' = 'center';
}
